module.exports = __webpack_public_path__ + "static/media/waterfall-horizontal.4cd667d1.jpg";